import { appConfiguration } from '../app-starter';
export const DEFAULT_COUNTRY_LANGUAGE = 'en-WW';


export function detectLocale(lang = document.documentElement.lang || DEFAULT_COUNTRY_LANGUAGE) {
  return lang;
}

export function getAppLocale() {
  let locale = appConfiguration.locale;
  if (!locale) {
    locale = detectLocale();
    appConfiguration.locale = locale
  }

  return locale;
}

/**
 * Returns { lang, country }
 */
export function getAppLocaleAsObject() {
  const locale = getAppLocale();
  const [lang = 'en', country = 'WW'] = locale.split('-');
  return { lang, country };
};
